export default "__VITE_ASSET__BdkwP6$Z__"